var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var UpdateTagsController = /** @class */ (function () {
                /** @ngInject **/
                function UpdateTagsController($mdDialog, tags) {
                    this.$mdDialog = $mdDialog;
                    this.tags = tags;
                    this.selectedTag = null;
                    this.name = null;
                    this.color = null;
                    this.tooltip = null;
                }
                UpdateTagsController.prototype.updateTag = function () {
                    this.$mdDialog.hide(__assign({}, angular.copy(this.selectedTag), { color: this.color, name: this.name, tooltip: this.tooltip }));
                    this.selectedTag.name = this.name;
                    this.selectedTag.color = this.color;
                    this.selectedTag.tooltip = this.tooltip;
                    this.selectedTag = null;
                };
                UpdateTagsController.prototype.selectTag = function () {
                    if (!!this.selectedTag) {
                        if (this.selectedTag.color === "blue") {
                            this.color = "#0000ff";
                        }
                        else {
                            this.color = this.selectedTag.color;
                        }
                        this.name = this.selectedTag.name;
                        this.tooltip = this.selectedTag.tooltip;
                    }
                };
                UpdateTagsController.prototype.closeDialog = function () {
                    this.$mdDialog.cancel();
                };
                return UpdateTagsController;
            }());
            minhasTarefas.UpdateTagsController = UpdateTagsController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.UpdateTagsController", UpdateTagsController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));
